import SmoothScroll from 'smooth-scroll';

var scroll = new SmoothScroll('a[href*="#"]');
